import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { GetGroupsAdminResponse, GetUserProjectsResponse, GetUsersAdminResponse, InviteUserRequest, InviteUserResponse } from '@types';
import { sec } from './security';

// this service file uses the same host as the main service.ts file,
// but defines admin-specific endpoints, and is kept separate to
// keep concerns isolated
const { VITE_SERVICE_HOST } = import.meta.env;

// Define a service using a base URL and expected endpoints
export const service = createApi({
  tagTypes: ['UsersAdmin'],
  reducerPath: 'serviceAdmin',
  baseQuery: fetchBaseQuery({
    baseUrl: VITE_SERVICE_HOST,
    prepareHeaders: async (headers) => {
      const access_token = await sec.getAccessTokenSilently()();
      if (access_token) headers.set('Authorization', `Bearer ${access_token}`);
      return headers;
    }
  }),
  endpoints: (builder) => ({
    // fetch users
    fetchUsers: builder.query<GetUsersAdminResponse[], void>({
      providesTags: ['UsersAdmin'],
      query: () => ({
        method: 'GET',
        url: '/v0/admin/users'
      })
    }),
    fetchGroups: builder.query<GetGroupsAdminResponse[], void>({
      query: () => ({
        method: 'GET',
        url: '/v0/admin/groups'
      })
    }),
    fetchProjectsForUser: builder.query<GetUserProjectsResponse, { user_email: string }>({
      query: ({ user_email }) => ({
        method: 'POST',
        url: `/v0/admin/users/projects`,
        body: { user_email }
      })
    }),
    inviteUser: builder.mutation<InviteUserResponse, InviteUserRequest>({
      invalidatesTags: ['UsersAdmin'],
      query: (body) => ({
        method: 'POST',
        url: '/v0/admin/invite',
        body
      })
    }),
    searchUsers: builder.query<string[], { email: string }>({
      query: ({ email }) => ({
        method: 'GET',
        url: `/v0/admin/users/search?email=${encodeURIComponent(email)}`
      })
    })
  })
});
export const {
  // \n
  useFetchUsersQuery,
  useFetchGroupsQuery,
  useFetchProjectsForUserQuery,
  useInviteUserMutation,
  useSearchUsersQuery
} = service;
